type Shipment = {
  isSelected: boolean;
  carrierPreference: string;
  shipper: {
    line1: string;
    city: string;
    state: string;
    country: string;
    pincode: number | string;
    name: string;
    phoneNumber: number;
    telephoneCode: number;
    email: string;
  };
  consignee: {
    line1: string;
    city: string;
    state: string;
    country: string;
    pincode: number | string;
    companyName: string;
    name: string;
    phoneNumber: number;
    telephoneCode: number;
    email: string;
  };
  package: {
    unitOfMeasurement: string;
    packaging: boolean;
    insurance: boolean;
    isDocument: boolean;
    currency: string;
    shipmentMode: string;
    isCod: boolean;
    isDropOff: boolean;
    pickupDate: any;
    timeSlot: string;
    codAmount: number;
    box: {
      id: string;
      length: number;
      width: number;
      height: number;
      weight: number;
      boxCopyCount: number;
      products: any[];
      selected: boolean;
    }[];
    totalBoxWeight: number;
    invoiceNumber: string;
    userReferenceNumber: string;
  };
};

type TransformedShipment = {
  destination: {
    city: string;
    state: string;
    country: string;
    pincode: string | number;
  };
  source: {
    city: string;
    state: string;
    country: string;
    pincode: string | number;
  };
  shipmentType: string;
  weight: number;
  package: {
    box: {
      weight: string | number;
      length: number;
      width: number;
      height: number;
    }[];
    unitOfMeasurement: string;
  };
  document: boolean;
  dropOff: boolean;
  userId: string;
  organizationName: boolean;
};

export function transformShipments(shipments: Shipment[], userId: string): { data: TransformedShipment[] } {
  const data: TransformedShipment[] = shipments.map(shipment => ({
    destination: {
      city: shipment.consignee.city,
      state: shipment.consignee.state,
      country: shipment.consignee.country,
      pincode: String(shipment.consignee.pincode),
    },
    source: {
      city: shipment.shipper.city,
      state: shipment.shipper.state,
      country: shipment.shipper.country,
      pincode: String(shipment.shipper.pincode),
    },
    shipmentType: shipment.package?.isDocument ? 'document' : 'parcel',
    weight: shipment.package.totalBoxWeight,
    package: {
      box: shipment.package.box.map(b => ({
        weight: b.weight,
        length: b.length,
        width: b.width,
        height: b.height,
      })),
      unitOfMeasurement: shipment.package.unitOfMeasurement,
    },
    document: shipment.package.isDocument,
    dropOff: shipment.package.isDropOff,
    userId: userId,
    organizationName: true,
  }));

  return { data };
}
